import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';
import { companyProfileInfoForUser } from '../../../../API/Settings/Company Settings/companySettingsAPI';
import { ListPosPaymentSummaryAPI, ListPosShifReportAPI, ListPosShifReportSalesAPI, ListPosShifReportWalletAPI } from './ReportAPI';

const PosShiftReportPrint = (props) => {
    const { branch, shift, selectedTab, showDetails } = props;
    const companyProfileData = useSelector(
        (state) => state?.companyProfileSlice?.userValue
    );
    const posSettingsList = useSelector((state) => state.posSettingSlice.apiResList);

    const shiftSalesReport = useSelector(
        (state) => state.posReportshiftSlice.shiftReportSale);
    const decimalPosition = localStorage.getItem("decimalPosition");

    const shiftReportpayment = useSelector(
        (state) => state.posReportshiftSlice.shiftReporPayment);

    const shiftReportwallet = useSelector(
        (state) => state.posReportshiftSlice.shiftReportWalletPay);

    const productSummmary = useSelector(
        (state) => state.posReportshiftSlice.shiftReport);

    const paymentSummmary = useSelector(
        (state) => state.posReportshiftSlice.shiftReporPaymentSummary);
    const checkinSummary = useSelector(
        (state) => state.posReportshiftSlice.shiftReporCheckinSummary
    );
    const offersSummary = useSelector(
        (state) => state.posReportshiftSlice.shiftReportOffersSummary
    );
    const formatDate = (dateTimeString) => {
        return dateTimeString?.split(' ')[0]; // Split the string by space and return the first part (the date)
    };


        // Enhanced print styles
    const printStyles = {
        page: {
            padding: '10mm',
            margin: 0,
            fontFamily: 'Arial, sans-serif',
            fontSize: '12px',
        },
        header: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            marginBottom: '15px',
            pageBreakAfter: 'avoid'
        },
        sectionContainer: {
            pageBreakInside: 'avoid',
            marginBottom: '20px'
        },
        sectionHeader: {
            backgroundColor: 'rgb(150 148 148)',
            border: 'none',
            padding: '5px 10px',
            margin: '10px 0 5px 0',
            fontWeight: 'bold',
            width: '100%',
            textAlign: 'left',
            pageBreakAfter: 'avoid'
        },
        table: {
            width: '100%',
            borderCollapse: 'collapse',
            pageBreakInside: 'avoid',
            marginBottom: '5px'
        },
        tableHeader: {
            backgroundColor: '#f0f0f0',
            fontWeight: 'bold',
            // position: 'sticky',
            // top: 0,
            // zIndex: 1
        },
        tableRow: {
            pageBreakInside: 'avoid',
            pageBreakAfter: 'auto'
        },
        totalRow: {
            backgroundColor: 'rgb(150 148 148)',
            fontWeight: 'bold',
            textAlign: 'right',
            padding: '5px',
            // pageBreakBefore: 'avoid'
        }
    };
    const checkinRecords = checkinSummary?.empCheckIn || [];

    const toNumber = (v) => {
        const n = Number(v);
        return Number.isFinite(n) ? n : 0;
    };

    const formatMoney = (v) => {
        const dp = Number(decimalPosition) || 2;
        return toNumber(v).toFixed(dp);
    };

    const shouldShow = (key) => {
        if (!selectedTab) return true;
        return String(selectedTab).toLowerCase() === String(key).toLowerCase();
    };

    const offerOrders = (offersSummary?.orders || []) || [];
    const offerTotalOrders = offerOrders.length;
    const offerTotalDiscount = offerOrders.reduce((sum, o) => sum + toNumber(o?.discountAmount ?? o?.discountAmt), 0);
    const offerTotalAmount = offerOrders.reduce((sum, o) => sum + toNumber(o?.amtTotal), 0);


    return (
        <div style={printStyles.page}>
            {/* Header Section*/}
            <div style={printStyles.header}>
                <div>
                    <img src={companyProfileData?.companyLogo} alt="" style={{ height: "50px" }} />
                </div>
                <div style={{ textAlign: "center" }}>
                    <h1 style={{ fontSize: "16px", margin: "0 0 5px 0" }}>Shift Report</h1>
                    <div style={{ display: "flex", justifyContent: "center", alignItems: 'center' }}>
                        <p style={{ margin: "0", fontSize: "12px" }}>{branch?.branchName}</p>
                        <div style={{ borderLeft: "1px solid black", height: "15px", margin: "0 10px" }}></div>
                        <p style={{ margin: "0", fontSize: "12px" }}>{shift?.shiftSeq || shift?.SHIFID || ''}</p>
                    </div>
                    <p style={{ margin: "0", fontSize: "12px", whiteSpace: 'nowrap' }}>
                        {`start - ${formatDate(shiftSalesReport?.shiftData?.startDate)}  To  end - ${formatDate(shiftSalesReport?.shiftData?.endDate)}`}
                    </p>
                </div>
                <div style={{ textAlign: "right" }}>
                    <h1 style={{ fontSize: "14px", margin: "0 0 5px 0" }}>{companyProfileData?.companyName}</h1>
                    <p style={{ margin: "0 0 2px 0", fontSize: "11px" }}>{companyProfileData?.companyAddress}</p>
                    <p style={{ margin: "0", fontSize: "11px" }}>{companyProfileData?.companyContact}</p>
                </div>
            </div>

            {/* Sales Section */}
            {shouldShow('sales') && (
                <div style={printStyles.sectionContainer}>
                    <div style={printStyles.sectionHeader}>SALES{showDetails ? ' (WITH DETAILS)' : ''}</div>
                    <table style={printStyles.table}>
                        <thead>
                            <tr style={printStyles.tableHeader}>
                                <th style={{ padding: '5px', border: '1px solid #ddd' }}>Date</th>
                                <th style={{ padding: '5px', border: '1px solid #ddd' }}>Order Reff</th>
                                <th style={{ padding: '5px', border: '1px solid #ddd' }}>Customer</th>
                                <th style={{ padding: '5px', border: '1px solid #ddd' }}>Mobile</th>
                                <th style={{ padding: '5px', border: '1px solid #ddd' }}>Delivery Charge</th>
                                <th style={{ padding: '5px', border: '1px solid #ddd' }}>Tax</th>
                                <th style={{ padding: '5px', border: '1px solid #ddd' }}>Order Amount</th>
                                <th style={{ padding: '5px', border: '1px solid #ddd' }}>Paid Amount</th>
                                <th style={{ padding: '5px', border: '1px solid #ddd' }}>Balance</th>
                            </tr>
                        </thead>
                        <tbody>
                            {shiftSalesReport?.sale?.length > 0 ? (
                                shiftSalesReport.sale.map((r, i) => (
                                    <React.Fragment key={i}>
                                        <tr style={{
                                            ...printStyles.tableRow,
                                            backgroundColor: i % 2 === 0 ? "white" : "#f9f9f9"
                                        }}>
                                            <td style={{ padding: '5px', border: '1px solid #ddd', whiteSpace: 'nowrap' }}>{formatDate(r.orderDate)}</td>
                                            <td style={{ padding: '5px', border: '1px solid #ddd', whiteSpace: 'nowrap' }}>{r.name}</td>
                                            <td style={{ padding: '5px', border: '1px solid #ddd', whiteSpace: 'nowrap' }}>{r.customerName}</td>
                                            <td style={{ padding: '5px', border: '1px solid #ddd', whiteSpace: 'nowrap' }}>{r.mobileNo}</td>
                                            <td style={{ padding: '5px', border: '1px solid #ddd', textAlign: 'right' }}>{r.deliveryCharge}</td>
                                            <td style={{ padding: '5px', border: '1px solid #ddd', textAlign: 'right' }}>{formatMoney(toNumber(r.totalExclusive) + toNumber(r.totalInclusive))}</td>
                                            <td style={{ padding: '5px', border: '1px solid #ddd', textAlign: 'right' }}>{r.amtTotal}</td>
                                            <td style={{ padding: '5px', border: '1px solid #ddd', textAlign: 'right' }}>{r.paidAmt}</td>
                                            <td style={{ padding: '5px', border: '1px solid #ddd', textAlign: 'right' }}>{r.amountDue}</td>
                                        </tr>
                                        {showDetails && r.orderInfo?.length > 0 && (
                                            <tr>
                                                <td colSpan={9} style={{ padding: '0', border: '1px solid #ddd' }}>
                                                    <table style={{ width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed' }}>
                                                        <colgroup>
                                                            <col style={{ width: '4%' }} />
                                                            <col style={{ width: '22%' }} />
                                                            <col style={{ width: '14%' }} />
                                                            <col style={{ width: '14%' }} />
                                                            <col style={{ width: '6%' }} />
                                                            <col style={{ width: '10%' }} />
                                                            <col style={{ width: '18%' }} />
                                                            <col style={{ width: '12%' }} />
                                                        </colgroup>
                                                        <thead>
                                                            <tr style={{ backgroundColor: '#eee8f5' }}>
                                                                <th style={{ padding: '3px 6px', fontSize: '10px', textAlign: 'center', borderBottom: '1px solid #ddd' }}>#</th>
                                                                <th style={{ padding: '3px 6px', fontSize: '10px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>Item</th>
                                                                <th style={{ padding: '3px 6px', fontSize: '10px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>Category</th>
                                                                <th style={{ padding: '3px 6px', fontSize: '10px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>POS Category</th>
                                                                <th style={{ padding: '3px 6px', fontSize: '10px', textAlign: 'center', borderBottom: '1px solid #ddd' }}>Qty</th>
                                                                <th style={{ padding: '3px 6px', fontSize: '10px', textAlign: 'right', borderBottom: '1px solid #ddd' }}>Rate</th>
                                                                <th style={{ padding: '3px 6px', fontSize: '10px', textAlign: 'right', borderBottom: '1px solid #ddd' }}>Tax</th>
                                                                <th style={{ padding: '3px 6px', fontSize: '10px', textAlign: 'right', borderBottom: '1px solid #ddd' }}>Total</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {r.orderInfo.map((item, idx) => (
                                                                <tr key={idx} style={{ backgroundColor: idx % 2 === 0 ? '#faf9ff' : '#f3f1fa' }}>
                                                                    <td style={{ padding: '2px 6px', fontSize: '10px', textAlign: 'center' }}>{idx + 1}</td>
                                                                    <td style={{ padding: '2px 6px', fontSize: '10px', textAlign: 'left' }}>{item.desccription}</td>
                                                                    <td style={{ padding: '2px 6px', fontSize: '10px', textAlign: 'left' }}>{item.categoryName || '-'}</td>
                                                                    <td style={{ padding: '2px 6px', fontSize: '10px', textAlign: 'left' }}>{item.posCategoryName || '-'}</td>
                                                                    <td style={{ padding: '2px 6px', fontSize: '10px', textAlign: 'center' }}>{item.qty}</td>
                                                                    <td style={{ padding: '2px 6px', fontSize: '10px', textAlign: 'right' }}>{formatMoney(item.unitPrice)}</td>
                                                                    <td style={{ padding: '2px 6px', fontSize: '10px', textAlign: 'right' }}>
                                                                        {item.taxes?.length > 0
                                                                            ? <>
                                                                                {item.taxes.map((t, ti) => (
                                                                                    <div key={ti} style={{ fontSize: '8px', lineHeight: '1.3', color: '#666' }}>
                                                                                        {t.taxName || 'Tax'} ({toNumber(t.amount)}%)
                                                                                    </div>
                                                                                ))}
                                                                                <div style={{ fontSize: '9px', fontWeight: 'bold', borderTop: item.taxes.length > 1 ? '1px solid #ddd' : 'none', marginTop: '1px' }}>
                                                                                    {formatMoney(Math.abs(toNumber(item.lineTotal) - toNumber(item.subTotalWoTax)))}
                                                                                </div>
                                                                            </>
                                                                            : '-'
                                                                        }
                                                                    </td>
                                                                    <td style={{ padding: '2px 6px', fontSize: '10px', textAlign: 'right' }}>{formatMoney(item.lineTotal)}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        )}
                                    </React.Fragment>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={9} style={{ padding: '5px', textAlign: 'center' }}>NO DATA</td>
                                </tr>
                            )}
                        </tbody>
                        <tfoot>
                            <tr style={{ backgroundColor: 'rgb(150 148 148)', fontWeight: 'bold' }}>
                                <td colSpan={5} style={{ padding: '5px', border: '1px solid #ddd', textAlign: 'right' }}>TOTAL</td>
                                <td style={{ padding: '5px', border: '1px solid #ddd', textAlign: 'right' }}></td>
                                <td style={{ padding: '5px', border: '1px solid #ddd', textAlign: 'right' }}>{formatMoney(shiftSalesReport?.sale?.reduce((acc, current) => acc + toNumber(current?.amtTotal), 0))}</td>
                                <td style={{ padding: '5px', border: '1px solid #ddd', textAlign: 'right' }}>{formatMoney(shiftSalesReport?.sale?.reduce((acc, current) => acc + toNumber(current?.paidAmt), 0))}</td>
                                <td style={{ padding: '5px', border: '1px solid #ddd', textAlign: 'right' }}>{formatMoney(shiftSalesReport?.sale?.reduce((acc, current) => acc + toNumber(current?.amountDue), 0))}</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            )}

            {/* Payment Section */}
            {shouldShow('payment') && (
                <div style={printStyles.sectionContainer}>
                    <div style={printStyles.sectionHeader}>PAYMENT</div>
                    <table style={printStyles.table}>
                        <thead>
                            <tr style={printStyles.tableHeader}>
                                <th style={{ padding: '5px', border: '1px solid #ddd' }}>Date</th>
                                <th style={{ padding: '5px', border: '1px solid #ddd' }}>Payment Reff</th>
                                <th style={{ padding: '5px', border: '1px solid #ddd' }}>Order Reff</th>
                                <th style={{ padding: '5px', border: '1px solid #ddd' }}>Customer</th>
                                <th style={{ padding: '5px', border: '1px solid #ddd' }}>Payment Method</th>
                                <th style={{ padding: '5px', border: '1px solid #ddd' }}>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {shiftReportpayment?.sale?.length > 0 ? (
                                shiftReportpayment.sale.map((r, i) => (
                                    <tr key={i} style={{
                                        ...printStyles.tableRow,
                                        backgroundColor: i % 2 === 0 ? "white" : "#f9f9f9"
                                    }}>
                                        <td style={{ padding: '5px', border: '1px solid #ddd' }}>{formatDate(r.paymentDate)}</td>
                                        <td style={{ padding: '5px', border: '1px solid #ddd' }}>{r.name}</td>
                                        <td style={{ padding: '5px', border: '1px solid #ddd' }}>{r.orderName}</td>
                                        <td style={{ padding: '5px', border: '1px solid #ddd' }}>{r.customerName}</td>
                                        <td style={{ padding: '5px', border: '1px solid #ddd' }}>{r.type}</td>
                                        <td style={{ padding: '5px', border: '1px solid #ddd', textAlign: 'right' }}>{formatMoney(r.amount)}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={6} style={{ padding: '5px', textAlign: 'center' }}>NO DATA</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                    <div style={printStyles.totalRow}>
                        <span style={{ marginRight: '20px' }}>TOTAL</span>
                        <span>{formatMoney(shiftReportpayment?.sale?.reduce((acc, current) => acc + toNumber(current?.amount), 0))}</span>
                    </div>
                </div>
            )}

            {/* Wallet Section (conditionally rendered) */}
            {shouldShow('wallet') && posSettingsList?.activeWalletStatus && shiftReportwallet?.sale?.length > 0 && (
                <div style={printStyles.sectionContainer}>
                    <div style={printStyles.sectionHeader}>WALLET</div>
                    <table style={printStyles.table}>
                        <thead>
                            <tr style={printStyles.tableHeader}>
                                <th style={{ padding: '5px', border: '1px solid #ddd' }}>Date</th>
                                <th style={{ padding: '5px', border: '1px solid #ddd' }}>Wallet Reff</th>
                                <th style={{ padding: '5px', border: '1px solid #ddd' }}>Order Reff</th>
                                <th style={{ padding: '5px', border: '1px solid #ddd' }}>Customer</th>
                                <th style={{ padding: '5px', border: '1px solid #ddd' }}>Payment Method</th>
                                <th style={{ padding: '5px', border: '1px solid #ddd' }}>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {shiftReportwallet.sale.map((r, i) => (
                                <tr key={i} style={{
                                    ...printStyles.tableRow,
                                    backgroundColor: i % 2 === 0 ? "white" : "#f9f9f9"
                                }}>
                                    <td style={{ padding: '5px', border: '1px solid #ddd' }}>{formatDate(r.paymentDate)}</td>
                                    <td style={{ padding: '5px', border: '1px solid #ddd' }}>{r.name}</td>
                                    <td style={{ padding: '5px', border: '1px solid #ddd' }}>{r.orderName}</td>
                                    <td style={{ padding: '5px', border: '1px solid #ddd' }}>{r.customerName}</td>
                                    <td style={{ padding: '5px', border: '1px solid #ddd' }}>{r.type}</td>
                                    <td style={{ padding: '5px', border: '1px solid #ddd' }}>{r.amount}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div style={printStyles.totalRow}>
                        <span style={{ marginRight: '20px' }}>TOTAL</span>
                        <span>{formatMoney(shiftReportwallet.sale.reduce((acc, current) => acc + toNumber(current?.amount), 0))}</span>
                    </div>
                </div>
            )}

            {/* Product Summary Section */}
            {shouldShow('product Summary') && (
                <div style={printStyles.sectionContainer}>
                    <div style={printStyles.sectionHeader}>PRODUCT SUMMARY{showDetails ? ' (WITH DETAILS)' : ''}</div>
                    <table style={printStyles.table}>
                        <thead>
                            <tr style={printStyles.tableHeader}>
                                <th style={{ padding: '5px', border: '1px solid #ddd' }}>Product</th>
                                <th style={{ padding: '5px', border: '1px solid #ddd' }}>Qty</th>
                                <th style={{ padding: '5px', border: '1px solid #ddd' }}>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {productSummmary?.sale?.length > 0 ? (
                                productSummmary.sale.map((r, i) => (
                                    <React.Fragment key={i}>
                                        <tr style={{
                                            ...printStyles.tableRow,
                                            backgroundColor: i % 2 === 0 ? "white" : "#f9f9f9"
                                        }}>
                                            <td style={{ padding: '5px', border: '1px solid #ddd' }}>{r.productName}</td>
                                            <td style={{ padding: '5px', border: '1px solid #ddd' }}>{r.totalQty}</td>
                                            <td style={{ padding: '5px', border: '1px solid #ddd', textAlign: 'right' }}>{formatMoney(r.amount)}</td>
                                        </tr>
                                        {showDetails && r.recipeComponents?.length > 0 && (
                                            <tr>
                                                <td colSpan={3} style={{ padding: '0', border: '1px solid #ddd' }}>
                                                    <table style={{ width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed' }}>
                                                        <colgroup>
                                                            <col style={{ width: '6%' }} />
                                                            <col style={{ width: '52%' }} />
                                                            <col style={{ width: '20%' }} />
                                                            <col style={{ width: '22%' }} />
                                                        </colgroup>
                                                        <thead>
                                                            <tr style={{ backgroundColor: '#eee8f5' }}>
                                                                <th style={{ padding: '3px 6px', fontSize: '10px', textAlign: 'center', borderBottom: '1px solid #ddd' }}>#</th>
                                                                <th style={{ padding: '3px 6px', fontSize: '10px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>Component</th>
                                                                <th style={{ padding: '3px 6px', fontSize: '10px', textAlign: 'center', borderBottom: '1px solid #ddd' }}>Qty</th>
                                                                <th style={{ padding: '3px 6px', fontSize: '10px', textAlign: 'center', borderBottom: '1px solid #ddd' }}>Unit</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {r.recipeComponents.map((comp, idx) => (
                                                                <tr key={idx} style={{ backgroundColor: idx % 2 === 0 ? '#faf9ff' : '#f3f1fa' }}>
                                                                    <td style={{ padding: '2px 6px', fontSize: '10px', textAlign: 'center' }}>{idx + 1}</td>
                                                                    <td style={{ padding: '2px 6px', fontSize: '10px', textAlign: 'left' }}>{comp.productName}</td>
                                                                    <td style={{ padding: '2px 6px', fontSize: '10px', textAlign: 'center' }}>{comp.quantity}</td>
                                                                    <td style={{ padding: '2px 6px', fontSize: '10px', textAlign: 'center' }}>{comp.uomName}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        )}
                                    </React.Fragment>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={3} style={{ padding: '5px', textAlign: 'center' }}>NO DATA</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                    <div style={printStyles.totalRow}>
                        <span style={{ marginRight: '20px' }}>TOTAL</span>
                        <span>{formatMoney(productSummmary?.sale?.reduce((acc, current) => acc + toNumber(current?.amount), 0))}</span>
                    </div>
                </div>
            )}

            {/* Payment Summary Section */}
            {shouldShow('payment summary') && (
                <div style={printStyles.sectionContainer}>
                    <div style={printStyles.sectionHeader}>PAYMENT SUMMARY</div>
                    <table style={printStyles.table}>
                        <thead>
                            <tr style={printStyles.tableHeader}>
                                <th style={{ padding: '5px', border: '1px solid #ddd' }}>Payment Method</th>
                                <th style={{ padding: '5px', border: '1px solid #ddd' }}>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {paymentSummmary?.sale?.length > 0 ? (
                                paymentSummmary.sale.map((r, i) => (
                                    <tr key={i} style={{
                                        ...printStyles.tableRow,
                                        backgroundColor: i % 2 === 0 ? "white" : "#f9f9f9"
                                    }}>
                                        <td style={{ padding: '5px', border: '1px solid #ddd' }}>{r.type}</td>
                                        <td style={{ padding: '5px', border: '1px solid #ddd', textAlign: 'right' }}>{formatMoney(r.amount)}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={2} style={{ padding: '5px', textAlign: 'center' }}>NO DATA</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                    <div style={printStyles.totalRow}>
                        <span style={{ marginRight: '20px' }}>TOTAL</span>
                        <span>{formatMoney(paymentSummmary?.sale?.reduce((acc, current) => acc + toNumber(current?.amount), 0))}</span>
                    </div>
                </div>
            )}

            {shouldShow('offers applied') && (
                <div style={printStyles.sectionContainer}>
                    <div style={printStyles.sectionHeader}>OFFERS APPLIED</div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                        <div><strong>Total Orders:</strong> {offerTotalOrders}</div>
                        <div><strong>Total Discount:</strong> {formatMoney(offerTotalDiscount)}</div>
                        <div><strong>Total Order Value:</strong> {formatMoney(offerTotalAmount)}</div>
                    </div>
                    <table style={printStyles.table}>
                        <thead>
                            <tr style={printStyles.tableHeader}>
                                <th style={{ padding: '5px', border: '1px solid #ddd' }}>Order Date</th>
                                <th style={{ padding: '5px', border: '1px solid #ddd' }}>Order Ref</th>
                                <th style={{ padding: '5px', border: '1px solid #ddd' }}>Customer</th>
                                <th style={{ padding: '5px', border: '1px solid #ddd' }}>Offer Code</th>
                                <th style={{ padding: '5px', border: '1px solid #ddd' }}>Offer Type</th>
                                <th style={{ padding: '5px', border: '1px solid #ddd' }}>Order Amount</th>
                                <th style={{ padding: '5px', border: '1px solid #ddd' }}>Discount</th>
                                <th style={{ padding: '5px', border: '1px solid #ddd' }}>Paid</th>
                                <th style={{ padding: '5px', border: '1px solid #ddd' }}>Payment</th>
                            </tr>
                        </thead>
                        <tbody>
                            {offerOrders?.length > 0 ? (
                                offerOrders.map((o, i) => (
                                    <tr key={i} style={{
                                        ...printStyles.tableRow,
                                        backgroundColor: i % 2 === 0 ? 'white' : '#f9f9f9'
                                    }}>
                                        <td style={{ padding: '5px', border: '1px solid #ddd', whiteSpace: 'nowrap' }}>{o.orderDate || '-'}</td>
                                        <td style={{ padding: '5px', border: '1px solid #ddd', whiteSpace: 'nowrap' }}>{o.orderRef || o.name || '-'}</td>
                                        <td style={{ padding: '5px', border: '1px solid #ddd', whiteSpace: 'nowrap' }}>{o.customerName || 'Walk-in'}</td>
                                        <td style={{ padding: '5px', border: '1px solid #ddd', fontFamily: 'monospace', whiteSpace: 'nowrap' }}>{o.offerCode || '-'}</td>
                                        <td style={{ padding: '5px', border: '1px solid #ddd' }}>{o.promoType || '-'}</td>
                                        <td style={{ padding: '5px', border: '1px solid #ddd', textAlign: 'right' }}>{formatMoney(o.amtTotal)}</td>
                                        <td style={{ padding: '5px', border: '1px solid #ddd', textAlign: 'right' }}>{formatMoney(o.discountAmount ?? o.discountAmt)}</td>
                                        <td style={{ padding: '5px', border: '1px solid #ddd', textAlign: 'right' }}>{formatMoney(o.paidAmt)}</td>
                                        <td style={{ padding: '5px', border: '1px solid #ddd' }}>{o.paymentMethod || '-'}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={9} style={{ padding: '5px', textAlign: 'center' }}>NO DATA</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            )}
            {shouldShow('checkin summary') && (
                <>
                    {/* checkin summery for print*/}
                    <a style={{fontSize:"medium",fontWeight:"bold"}}>CheckIn Summery</a>
                    <div style={{ paddingInline: "11px" }}>
                        {checkinRecords.map((checkin, idx) => {
                const paymentData = checkin.posOrderCount?.cashCardSummary.data || [];
                          
                                          const orderData = checkin.posOrderCount?.posOrderSummary || [];

            
                            const totalPayment = paymentData.reduce((sum, item) => sum + (item.totalAmount || 0), 0);
                            const totalOrders = orderData.reduce((sum, item) => sum + (item.count || 0), 0);
                            const totalOrderAmount = orderData.reduce((sum, item) => sum + (item.amtTotal || 0), 0);
            
                            return (
                                <div key={checkin._id} style={{ marginBottom: "40px", borderBottom: "2px solid #ccc", paddingBottom: "20px" }}>
                                    {/* Main Header */}
                                    <div style={{
                                        backgroundColor: 'rgb(183 196 230)',
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        padding: '10px 20px',
                                        fontWeight: 'bold'
                                    }}>
                                        <span>{checkin.empData?.staff_name || '--'}</span>
                                        <div style={{ display: 'flex', gap: '20px', fontSize: '14px' }}>
                                            <span style={{ color: 'green' }}>🟢 Check In: {checkin.checkInDate}</span>
                                            <span style={{ color: '#black' }}>🟣 Time: {checkin.checkInTime}</span>
                                            {checkin.checkOutDate && (
                                                <>
                                                    <span style={{ color: 'red' }}>🔴 Check Out: {checkin.checkOutDate}</span>
                                                    <span style={{ color: '#black' }}>🔵 Time: {checkin.checkOutTime}</span>
                                                </>
                                            )}
                                        </div>
                                    </div>
            
                                    {/* Payment Summary */}
                                    <div style={{ marginTop: '20px' }}>
                                        <div style={{ backgroundColor: '#f0f0f0', padding: '10px 15px', fontWeight: 'bold', marginTop: "-16px" }}>
                                            Payment Summary
                                        </div>
            
                                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                            <thead>
                                                <tr style={{ backgroundColor: '#e0e0e0', textAlign: 'left' }}>
                                                    <th style={{ padding: '10px' }}>Type</th>
                                                    <th style={{ padding: '10px' }}>Commission</th>
                                                    <th style={{ padding: '10px', textAlign: 'right' }}>Total</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {paymentData.map((item, index) => (
                                                    <React.Fragment key={index}>
                                                        <tr style={{ backgroundColor: index % 2 === 0 ? '#fff' : '#f9f9f9' }}>
                                                            <td style={{ padding: '10px', textTransform: 'capitalize' }}>{item.name}</td>
                                                            <td style={{ padding: '10px' }}>₹{(item.totalCommission || 0)?.toFixed(2)}</td>
                                                            <td style={{ padding: '10px', textAlign: 'right' }}>₹{(item.totalAmount || 0)?.toFixed(2)}</td>
                                                        </tr>
            
                                                        {item.type === 'cash' && item?.denomination?.length > 0 && (
                                                            <tr>
                                                                <td colSpan={3} style={{ padding: '0px 0px 3px 16px' }}>
                                                                    <div style={{
                                                                        backgroundColor: '#f9f9f9',
                                                                        padding: '6px',
                                                                        borderRadius: '5px',
                                                                        maxWidth: '100%'
                                                                    }}>
                                                                        <div style={{ fontWeight: 'bold', marginBottom: '8px', backgroundColor: "#cab8b8" }}>Denomination</div>
                                                                        <table style={{ width: '100%', fontSize: '14px' }}>
                                                                            <thead>
                                                                                <tr style={{ fontWeight: 'bold' }}>
                                                                                    <td>Currency</td>
                                                                                    <td>Count</td>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {item.denomination.map((den, i) => (
                                                                                    <tr key={i}>
                                                                                        <td>₹{den.currency}</td>
                                                                                        <td>{den.count}</td>
                                                                                    </tr>
                                                                                ))}
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )}
            
                                                    </React.Fragment>
                                                ))}
                                                <tr style={{ backgroundColor: '#b0b0b0', fontWeight: 'bold' }}>
                                                    <td style={{ padding: '10px' }}>Total</td>
                                                    <td></td>
                                                    <td style={{ padding: '10px', textAlign: 'right' }}>₹{totalPayment.toFixed(2)}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
            
                                    {/* Order Summary */}
                                    <div style={{ marginTop: '30px' }}>
                                        <div style={{ backgroundColor: '#f0f0f0', padding: '10px 15px', fontWeight: 'bold' }}>
                                            Order Summary
                                        </div>
                                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                            <thead>
                                                <tr style={{ backgroundColor: '#e0e0e0', textAlign: 'left' }}>
                                                    <th style={{ padding: '10px' }}>Type</th>
                                                    <th style={{ padding: '10px' }}>Count</th>
                                        <th style={{ padding: '10px', textAlign: 'right' }}>Amount</th>

                                                </tr>
                                            </thead>
                                            <tbody>
                                                {orderData.map((order, i) => (
                                                    <tr key={i} style={{ backgroundColor: i % 2 === 0 ? '#fff' : '#f9f9f9' }}>
                                                        <td style={{ padding: '10px' }}>{order.ordType}</td>
                                                        <td style={{ padding: '10px' }}>{order.count}</td>
                                                        <td style={{ padding: '10px', textAlign: 'right' }}>{order.amtTotal}</td>
                                                    </tr>
                                                ))}
                                                <tr style={{ backgroundColor: '#b0b0b0', fontWeight: 'bold' }}>
                                                    <td style={{ padding: '10px' }}>Total</td>
                                                    <td style={{ padding: '10px' }}>{totalOrders}</td>
                                                    <td style={{ padding: '10px' , textAlign: 'right' }}>{totalOrderAmount}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            );
                        })}
            
            
                        
                            { checkinSummary?.branchWiseShift===false && (
                                <div style={{ marginBottom: "40px", borderBottom: "2px solid #ccc", paddingBottom: "20px" }}>
                                    {/* Main Header */}
                                    <div style={{
                                        backgroundColor: 'rgb(183 196 230)',
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        padding: '10px 20px',
                                        fontWeight: 'bold'
                                    }}>
                                        <span>{checkinSummary?.shiftData?.shiftSeq|| '--'}</span>
                                        <div style={{ display: 'flex', gap: '20px', fontSize: '14px' }}>
                                            <span style={{ color: 'green' }}>🟢 Check In: {checkinSummary?.shiftData?.startDate}</span>
                                            <span style={{ color: '#black' }}>🟣 Time: {checkinSummary?.shiftData?.startTime}</span>
            
                                                    <span style={{ color: 'red' }}>🔴 Check Out: {checkinSummary?.shiftData?.endDate}</span>
                                                    <span style={{ color: '#black' }}>🔵 Time: {checkinSummary?.shiftData?.endTime}</span>
                                               
                                           
                                        </div>
                                    </div>
            
                                    {/* Payment Summary */}
                                    <div style={{ marginTop: '20px' }}>
                                        <div style={{ backgroundColor: '#f0f0f0', padding: '10px 15px', fontWeight: 'bold', marginTop: "-16px" }}>
                                            Payment Summary
                                        </div>
            
                                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                            <thead>
                                                <tr style={{ backgroundColor: '#e0e0e0', textAlign: 'left' }}>
                                                    <th style={{ padding: '10px' }}>Type</th>
                                                    <th style={{ padding: '10px' }}>Commission</th>
                                                    <th style={{ padding: '10px', textAlign: 'right' }}>Total</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                { checkinSummary?.cashCardSummary?.data?.map((item, index) => (
                                                    <React.Fragment key={index}>
                                                        <tr style={{ backgroundColor: index % 2 === 0 ? '#fff' : '#f9f9f9' }}>
                                                            <td style={{ padding: '10px', textTransform: 'capitalize' }}>{item?.name}</td>
                                                            <td style={{ padding: '10px' }}>₹{(item?.totalCommission || 0)?.toFixed(2)}</td>
                                                            <td style={{ padding: '10px', textAlign: 'right' }}>₹{(item?.totalAmount || 0)?.toFixed(2)}</td>
                                                        </tr>
            
                                                        {item?.type === 'cash' && item.denomination?.length > 0 && (
                                                            <tr>
                                                                <td colSpan={3} style={{ padding: '0px 0px 3px 16px' }}>
                                                                    <div style={{
                                                                        backgroundColor: '#f9f9f9',
                                                                        padding: '6px',
                                                                        borderRadius: '5px',
                                                                        maxWidth: '100%'
                                                                    }}>
                                                                        <div style={{ fontWeight: 'bold', marginBottom: '8px', backgroundColor: "#cab8b8" }}>Denomination</div>
                                                                        <table style={{ width: '100%', fontSize: '14px' }}>
                                                                            <thead>
                                                                                <tr style={{ fontWeight: 'bold' }}>
                                                                                    <td>Currency</td>
                                                                                    <td>Count</td>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {item.denomination.map((den, i) => (
                                                                                    <tr key={i}>
                                                                                        <td>₹{den.currency}</td>
                                                                                        <td>{den.count}</td>
                                                                                    </tr>
                                                                                ))}
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )}
            
                                                    </React.Fragment>
                                                ))}
                                                <tr style={{ backgroundColor: '#b0b0b0', fontWeight: 'bold' }}>
                                                    <td style={{ padding: '10px' }}>Total</td>
                                                    <td></td>
                                                    <td style={{ padding: '10px', textAlign: 'right' }}>₹{checkinSummary?.cashCardSummary?.amountTotal?.toFixed(2)}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
            
                                    {/* Order Summary */}
                                    <div style={{ marginTop: '30px' }}>
                                        <div style={{ backgroundColor: '#f0f0f0', padding: '10px 15px', fontWeight: 'bold' }}>
                                            Order Summary
                                        </div>
                                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                            <thead>
                                                <tr style={{ backgroundColor: '#e0e0e0', textAlign: 'left' }}>
                                                    <th style={{ padding: '10px' }}>Type</th>
                                                    <th style={{ padding: '10px' }}>Count</th>
                                                    <th style={{ padding: '10px', textAlign: 'right'  }}>amount</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {checkinSummary?.posOrderSummary.map((order, i) => (
                                                    <tr key={i} style={{ backgroundColor: i % 2 === 0 ? '#fff' : '#f9f9f9' }}>
                                                        <td style={{ padding: '10px' }}>{order.ordType}</td>
                                                        <td style={{ padding: '10px' }}>{order.count}</td>
                                                        <td style={{ padding: '10px' , textAlign: 'right' }}>{order.amtTotal}</td>
                                                    </tr>
                                                ))}
                                                <tr style={{ backgroundColor: '#b0b0b0', fontWeight: 'bold' }}>
                                                    <td style={{ padding: '10px' }}>Total</td>
                                                <td></td>
                                                 <td style={{ padding: '10px', textAlign: 'right' }}> ₹{ checkinSummary?.posOrderSummary?.reduce((sum, order) => sum + (order.amtTotal || 0), 0).toFixed(2)  }</td> 
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )}
                      
                    </div>
                </>
            )}
        </div>
    )
}

export default PosShiftReportPrint